class FooterPrimary {
  private footerElement: HTMLElement | null;
  private backToTopButton!: HTMLElement | null;

  constructor() {

    this.footerElement = document.querySelector('footer');
    if (!this.footerElement) return;
    this.backToTopButton = document.querySelector<HTMLElement>('[data-footer-top]');

    if (this.backToTopButton) {
      this.backToTopButton.addEventListener('click', this.scrollToTop.bind(this));
    }
    document.addEventListener('DOMContentLoaded', this.handleScrollForButton.bind(this));
    window.addEventListener('scroll', this.handleScrollForButton.bind(this));
  }

  private scrollToTop(event: Event): void {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  private handleScrollForButton(): void {
    if (!this.backToTopButton) {
      return;
    }

    const viewportHeight = window.innerHeight;
    const scrollThreshold = viewportHeight * 0.6;
    const scrollPosition = window.scrollY;
    if (scrollPosition >= scrollThreshold) {
      this.backToTopButton.classList.add('active');
    } else {
      this.backToTopButton.classList.remove('active');
    }
  }
}

export const footer = new FooterPrimary();